<div class="organizations-container">
    <div class="organizations-label">
        <h2>{{translatorSvc.getLabel('organisations')}}</h2>
    </div>
    <div class="ingredients-list">
        <app-organisation-item class="organisation-list-item" *ngFor="let organisationItem of authSvc.User.organisations" [organisationItem]="organisationItem" (chooseOrganisation)="chooseOrganisation($event)"></app-organisation-item>
    </div>
</div>

